import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { AlertTriangle } from "lucide-react";

interface SensorEmptyStateProps {
  t: (key: string) => string;
}

export const SensorEmptyState: React.FC<SensorEmptyStateProps> = ({ t }) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="8px"
      py="16px"
    >
      <AlertTriangle size={24} color="#4A6075" />
      <Text
        fontWeight="700"
        fontSize="14px"
        lineHeight="20px"
        color="#4A6075"
        textAlign="center"
        maxW="314px"
      >
        {t("emptyStateTitle")}
      </Text>
    </Flex>
  );
};
